import { render, staticRenderFns } from "./IndagineEpidemiologicaEncefaliteMeningiteSMeningococciaViewComponent.vue?vue&type=template&id=4987c8f4"
import script from "./IndagineEpidemiologicaEncefaliteMeningiteSMeningococciaViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEncefaliteMeningiteSMeningococciaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports